module.exports = __webpack_public_path__ + "static/img/4.5026ed9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/zh/4.png
// module id = FxwI
// module chunks = 0